import http from "./http";

const post = (url, data) => http.post(url, Object.assign(data));

const get = (url, data) => http.get(url, Object.assign(data));

export const getMomentInfo = (params) => get("/social/moment/info", params);
export const getMommentCommentList = (params) => get("/social/comment/page", params);
